import script from "./StepsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsSection.vue?vue&type=script&setup=true&lang=js"

import "./StepsSection.vue?vue&type=style&index=0&id=5247a634&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5247a634"]])

export default __exports__